import { HTMLAttributes, ReactNode, SVGProps } from 'react';
import { badgeStyles, BadgeStyleVariants } from '../../patterns/badge';
import { twMerge } from 'tailwind-merge';
import { Typography } from '../typography/typography';
import { Avatar } from '../avatar/avatar';
import { StatusIcon } from '../statusIcon/statusIcon';
import { StatusIconStylesVariants } from '../statusIcon/variants';

type Props = {
  label: string;
  icon?: (props: SVGProps<SVGSVGElement>) => ReactNode;
  avatar?: {
    initials: string;
    src?: string;
    alt?: string;
  };
  status?: {
    color: StatusIconStylesVariants['color'];
    variant: StatusIconStylesVariants['variant'];
  };
} & BadgeStyleVariants &
  Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export function Badge(props: Props) {
  const {
    className,
    label,
    avatar,
    status,
    variant = 'outlined',
    spacing = 'default',
    icon: Icon,
    ...rest
  } = props;

  return (
    <div
      className={twMerge(badgeStyles({ variant, spacing }), className)}
      aria-label={label}
      {...rest}
    >
      {status && <StatusIcon {...status} />}
      {Icon && <Icon className="min-w-12 w-12 h-12" />}
      {avatar && <Avatar size={16} variant="rounded" {...avatar} />}

      <Typography variant="body-xs" weight="regular" className="text-nowrap">
        {label}
      </Typography>
    </div>
  );
}
